import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import './init-login'
import React from 'react'
import ReactDOM from 'react-dom'
import { createHashRouter, RouterProvider } from 'react-router-dom'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'normalize.css'
import { RecoilRoot } from 'recoil'
import { octopus } from '@/utils/octopus'
import './http'
import { REFRESH_URL, setDefaultRefreshUrl } from '@yuanfudao/metis-unified-login'
import { index as routes } from '@/routes'
import { MetisConfigProvider, legacyLogicalPropertiesTransformer, MetisConfigProviderProps } from '@yuanfudao/metis-web-component'
import { zhCN } from '@yuanfudao/metis-web-component/dist/locale'
import config from './config'

octopus.init()

// @ts-ignore
import('core-js/stable/string/replace-all')

dayjs.locale('zh-cn')

// 设置刷新token的URL
setDefaultRefreshUrl(REFRESH_URL.TENANT)

const router = createHashRouter(routes)

const defaultConfig: MetisConfigProviderProps = {
  locale: zhCN,
  transformers: [legacyLogicalPropertiesTransformer],
  baseUrl: config.HTTP_BASE_URL,
}

MetisConfigProvider.config({
  holderRender: (children) => (
    <MetisConfigProvider {...defaultConfig}>
      {children}
    </MetisConfigProvider>
  ),
})

ReactDOM.render(
  <MetisConfigProvider {...defaultConfig}>
    <RecoilRoot>
      <RouterProvider router={router} />
    </RecoilRoot>
  </MetisConfigProvider>,
  document.querySelector('#root'),
)
